import { defineMessages } from "react-intl";

import { ReservationType } from "@/features/bookings/types/types";

export const reservationTypesLabels = defineMessages({
  [ReservationType.PAST]: { id: "bookings.past", defaultMessage: "Past" },
  [ReservationType.UPCOMING]: {
    id: "bookings.upcoming",
    defaultMessage: "Upcoming",
  },
  [ReservationType.REFUNDED]: {
    id: "bookings.cancelled",
    defaultMessage: "Cancelled",
  },
});
